module.exports = __webpack_public_path__ + "static/TT-Testfit_Floor06-a3e01e3b4fcb7747f71e4c541be8f11e.jpg";